import { render, staticRenderFns } from "./MLAListSelection.vue?vue&type=template&id=12ab2d24&scoped=true"
import script from "./MLAListSelection.vue?vue&type=script&lang=js"
export * from "./MLAListSelection.vue?vue&type=script&lang=js"
import style0 from "./MLAListSelection.vue?vue&type=style&index=0&id=12ab2d24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ab2d24",
  null
  
)

export default component.exports